import { render } from "./ParticlesBackground.vue?vue&type=template&id=e2f94a32"
import script from "./ParticlesBackground.vue?vue&type=script&lang=js"
export * from "./ParticlesBackground.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__